module.exports = __webpack_public_path__ + "img/toast_error.3742c59b.png";